import { useEffect, useState } from "react";
import { Box, Card, Typography, Avatar, CircularProgress } from "@mui/material";
import { useCurrentUser } from "../utils/useCurrentUser";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function Profile() {
  const { empId, boId } = useCurrentUser();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  console.log("Current User - empId:", empId, "boId:", boId);

  useEffect(() => {
    // ❗ WAIT until both empId and boId are loaded
    if (!empId || !boId) return;

    setLoading(true);

    const fetchDetails = async () => {
      try {
        console.log("Fetching profile for empId:", empId, "boId:", boId);
        const res = await fetch(`${BASE_URL}/EmployeeDetails/${boId}/${empId}`);
        if (!res.ok) throw new Error("Failed to fetch profile");
        const json = await res.json();
        console.log("Profile data fetched:", json);
        setDetails(json);
      } catch (err) {
        console.error("Profile fetch failed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [empId, boId]); // 🔥 IMPORTANT: rerun when values are loaded

  if (!empId || !boId) {
    return <Typography>Loading user info…</Typography>;
  }

  if (loading) return <CircularProgress />;

  if (!details) return <Typography>No Profile Found</Typography>;

return (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      mt: { xs: 2, sm: 4 },
      px: 2,
      pb: 6,
    }}
  >
    <Card
      sx={{
        width: "100%",
        maxWidth: 600,
        borderRadius: 4,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        overflow: "hidden",
      }}
    >
      {/* Banner inside the card */}
      <Box
        sx={{
          height: { xs: 120, sm: 150 },
          background: "linear-gradient(135deg, #0A66C2 0%, #004182 100%)",
          position: "relative",
        }}
      >
        {/* Avatar Over Banner */}
        <Avatar
          sx={{
            width: { xs: 90, sm: 110 },
            height: { xs: 90, sm: 110 },
            border: "4px solid white",
            bgcolor: "#0A66C2",
            fontSize: { xs: 30, sm: 36 },
            position: "absolute",
            left: "50%",
            bottom: -40,
            transform: "translateX(-50%)",
            boxShadow: 3,
          }}
        >
          {`${details.first_name?.[0] ?? ""}${details.last_name?.[0] ?? ""}`
            .toUpperCase() || "U"}
        </Avatar>
      </Box>

      {/* Profile Info */}
      <Box sx={{ pt: 6, pb: 3, px: { xs: 2, sm: 4 } }}>
        {/* NAME */}
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            fontWeight: 600,
            mb: 0.5,
            fontSize: { xs: "1.3rem", sm: "1.6rem" },
          }}
        >
          {details.first_name} {details.last_name}
        </Typography>

        {/* DESIGNATION */}
        <Typography
          sx={{
            textAlign: "center",
            color: "text.secondary",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            mb: 3,
          }}
        >
          {details.designation || "—"}
        </Typography>

        {/* Info Section */}
        <Box>
          {[
            ["Email", details.bfx_email],
            ["Employee ID", details.emp_id],
            ["Mobile", details.mobile_1],
          ].map(([label, value]) => (
            <Box
              key={label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
                py: 1.5,
                borderBottom: "1px solid #eee",
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                  mb: { xs: 0.5, sm: 0 },
                }}
              >
                {label}
              </Typography>

              <Typography
                sx={{ fontWeight: 500, wordBreak: "break-word" }}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  </Box>
);



}
